import getEncyclopediaArticleBySlug from './getEncyclopediaArticleBySlug'
import getEncyclopediaArticles from './getEncyclopediaArticles'
import getEncyclopediaCategories from './getEncyclopediaCategories'
import getEncyclopediaCategoryBySlug from './getEncyclopediaCategoryBySlug'
import getEncyclopediaSubcategories from './getEncyclopediaSubcategories'
import getEncyclopediaSubcategoriesByCategorySlug from './getEncyclopediaSubcategoriesByCategorySlug'
import getEncyclopediaSubcategoryBySlug from './getEncyclopediaSubcategoryBySlug'
import searchEncyclopediaArticles from './searchEncyclopediaArticles'

const encyclopedia = {
  getEncyclopediaArticleBySlug,
  getEncyclopediaArticles,
  getEncyclopediaCategories,
  getEncyclopediaCategoryBySlug,
  getEncyclopediaSubcategories,
  getEncyclopediaSubcategoriesByCategorySlug,
  getEncyclopediaSubcategoryBySlug,
  searchEncyclopediaArticles
}

export default encyclopedia
